import PropTypes from 'prop-types'

import ProductItem from './ProductItem'

const ProductList = ({ products, currentTerm }) => {
  const listProducts = () => {
    return products
      .filter(product => product.price.to !== null)
      .map((product, index) =>
        <ProductItem key={index} {...product} currentTerm={currentTerm} />
      )
  }

  return (
    <div className="product-list padding-x-small">
      <div className="row no-margin">
        <h3 className="heading-4 no-margin">
          Produtos Relacionados
        </h3>
        <ul className="product-list-results no-margin">
          { listProducts() }
        </ul>
      </div>
    </div>
  )
}

ProductList.propTypes = {
  products: PropTypes.arrayOf(PropTypes.object)
}

export default ProductList
